module.exports = __webpack_public_path__ + "img/RadResistance.442f101e.png";